export function printStars(ratingPosition: number) {
  let stars = ""
  for (let i = 0; i < ratingPosition; i++) {
    stars += "★"
  }
  return stars
}
